@import (reference) '../../constants/spacing.module.less';

.reship-modal-content {
  min-height: 176px;
  gap: @space-16;
}

.loading-indicator {
  flex: 1;
}
